import React, { useContext } from 'react';
import styled from 'styled-components';
import { Feedback } from './Feedback';
import iconComments from '../images/fa-comments-alt.svg';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import default_logo from '../images/icon-default.png';
import pdflogo from '../images/icon-pdf.png';
import docx_logo from '../images/icon-docx.png';
import html_logo from '../images/icon-html.png';
import { BotResponseData } from '../types/MessageData';
import { backendProxy } from '../hooks/backendProxy';
import { ConversationContext } from '../contexts/ConversationContext';
import { MessageDebugInfo } from './MessageDebugInfo';

const BotMessageDiv = styled.div`
    width: 80%; margin-bottom: 30px;
    @media (max-width: 768px) {
        width: 100%;
    }
    .icon {
        position: relative; left: -80px; top: 30px;
        background-color: #CCE6D6; border-radius: 50%; width: 60px; height: 60px;
        @media (max-width: 768px) {
            display: none;
        }
        img {color: #000; margin-left: 11px; margin-top: 14px;}
    }
`

const ContentDiv = styled.div`
    display: block;
    ul {padding-left: 0; margin-top: 10px;}
    ol {padding-left: 30px;}
    ol, ul {color: #000;}
    ul li {list-style-type: disc; margin-left: 20px; margin-bottom: 5px;}
    ol li {margin-bottom: 5px;}
    ol li::marker {font-weight: 600;}
    hr {margin-top: 10px; margin-bottom: 20px;}
`

type BotMessageProps = {
    message: BotResponseData
};

export const BotMessage: React.FC<BotMessageProps> = ({ message }) => {
    const { clientId } = useContext(ConversationContext);

    const onLinkClick = async (evt: React.MouseEvent<HTMLAnchorElement>) => {
        const href = evt.currentTarget.href;
        await backendProxy.trackEvent('link-click', clientId, { href, messageId: message.messageId, label: evt.currentTarget.innerText })
        return href;
    }
    return (
        <BotMessageDiv>
            <div className="icon">
                <img src={iconComments} alt="Antwort von SmartSG" />
                {message.completed &&
                    <MessageDebugInfo message={message} />
                }
            </div>

            <ContentDiv>
                <Markdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    components={{
                        a({ href, children, className, ...props }) {
                            if ((typeof children) === "string") {
                                const label = children?.toString();
                                if (label && label.endsWith(")") && label.indexOf("(") >= 0) {
                                    const parts = label.split('(');
                                    const text = parts[0].trim();
                                    const fileExt = parts[1].replace(')', '').trim().toUpperCase();
                                    let icon = default_logo;
                                    switch (fileExt) {
                                        case 'DOCX': { icon = docx_logo; break; }
                                        case 'PDF': { icon = pdflogo; break; }
                                        case 'HTML': { icon = html_logo; break; }
                                    }
                                    children = <><img alt={fileExt} src={icon} width="20px" style={{marginRight: '5px', marginBottom: '-3px'}} title={fileExt}/><span>{text}</span></>;
                                }
                            }
                            return <a href={decodeURIComponent(href || '')} onClick={onLinkClick} target="_blank" rel="noopener noreferrer" className={`break-all ${className}`} {...props}>{children}</a>;
                        }
                    }}
                >
                    {message.content}
                </Markdown>
                { message.classification !== 'fixed-answer' && 
                    <Feedback message={message} />
                }
            </ContentDiv>
        </BotMessageDiv>
    )
}